import { ConsoleLogger } from './console-logger.js';
import { ArrayHelper } from '../../helpers/index.js';
export class AppLogger {
    static instance = new AppLogger();
    $name = 'app-logger';
    _loggers = [];
    _debugEnabled = false;
    constructor() { }
    debug(obj) {
        if (this._debugEnabled) {
            const updatedObj = {
                timestamp: Date.now(),
                ...obj,
            };
            for (const logger of this._loggers) {
                try {
                    logger.debug(updatedObj);
                }
                catch (e) {
                    console.error(e);
                }
            }
        }
    }
    error(obj) {
        const updatedObj = {
            timestamp: Date.now(),
            ...obj,
        };
        for (const logger of this._loggers) {
            try {
                logger.error(updatedObj);
            }
            catch (e) {
                console.error(e);
            }
        }
    }
    info(obj) {
        const updatedObj = {
            timestamp: Date.now(),
            ...obj,
        };
        for (const logger of this._loggers) {
            try {
                logger.info(updatedObj);
            }
            catch (e) {
                console.error(e);
            }
        }
    }
    configure(config) {
        this._debugEnabled = config.debugEnabled;
    }
    static configure(config) {
        AppLogger.instance.configure(config);
    }
    static debug(obj) {
        AppLogger.instance.debug(obj);
    }
    static error(obj) {
        AppLogger.instance.error(obj);
    }
    static info(obj) {
        AppLogger.instance.info(obj);
    }
    static addConsole() {
        if (!ArrayHelper.any(AppLogger.instance._loggers, (l) => l instanceof ConsoleLogger)) {
            AppLogger.instance._loggers.push(ConsoleLogger.instance);
        }
    }
    static add(logger) {
        AppLogger.instance._loggers.push(logger);
    }
}
//# sourceMappingURL=app-logger.js.map